import { Button } from '@servicetim/ui/components';
import { ChevronDown, ChevronUp } from 'lucide-react';

export interface ReorderButtonsProps {
  /** Name of the row, for the accessible labels. */
  label: string;
  onUp?: () => void;
  onDown?: () => void;
  disabled?: boolean;
}

/** Keyboard-friendly move up / move down pair (drag-free reordering). */
export function ReorderButtons({ label, onUp, onDown, disabled }: ReorderButtonsProps) {
  return (
    <span className="inline-flex items-center">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-7"
        aria-label={`Move ${label} up`}
        disabled={disabled || !onUp}
        onClick={onUp}
      >
        <ChevronUp />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-7"
        aria-label={`Move ${label} down`}
        disabled={disabled || !onDown}
        onClick={onDown}
      >
        <ChevronDown />
      </Button>
    </span>
  );
}
